const ExtraForm = () => null;

export default ExtraForm;
